/**
 * Intersection Observe Util
 *
 * Sets intersection observer to watch elements and perform
 * action once element visibility hits preset margin / threshold.
 *
 * @param {array} elements NodeList of elements to observe.
 * @param {function} callback Function to call on intersection occurance.
 * @param {object} settings Settings to override defaults.
 * @param {boolean} immediateCallback Run callback immediately instead of lazily.
 * @return {void}
 */
const observe = (elements, callback, settings = {}, immediateCallback = false) => {

	let elementObserver = null;

	if (elements.length && typeof callback === 'function') {

		// IntersectionObserver supported
		if (!immediateCallback && 'IntersectionObserver' in window) {

			const options = {
				rootMargin: '0px',
				threshold: 0.1,
				...settings
			};

			elementObserver = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0) {
						observer.unobserve(entry.target);
						callback(entry.target);
					}
				});
			}, options);

			elements.forEach((img) => {
				elementObserver.observe(img);
			});
		}

		// IntersectionObserver not supported
		else {
			elements.forEach(element => {
				callback(element);
			});
		}
	}

	return elementObserver;
};

export default observe;
